import { diff } from "deep-diff";

export const formatChanges = (changes: any[]) => {
  return changes?.filter(d => d.kind === "E").map((d: any) => ({
    property: d.path[1],
    oldValue: d.lhs,
    newValue: d.rhs
  }));
};

export const getFormattedDiffs = (oldData: any, newData: any) => {
  const changes = diff(oldData, newData);
  const filteredChanges = changes?.filter(d => d.kind === "E");

  if (!changes || !filteredChanges || filteredChanges.length === 0) return;

  const formattedDiffs = formatChanges(changes);

  return formattedDiffs;
}
